import { Errors, PingFederateError } from './errors.interfaces';
import { MfaLinks, User } from './multi-factor-authentication.interfaces';
import { AuthorizeResponse } from './oauth.interfaces';

export type LoginRememberMeOperationTypes =
  | 'INITIATE_LOGIN'
  | 'POST_WITH_CRED'
  | 'REDIRECTFUL_LOGIN'
  | 'REDIRECTFUL_POST_WITH_CRED'
  | 'PASSWORDLESS_LOGIN'
  | 'PASSWORDLESS_LOGIN_WITH_CRED'
  | 'DEFAULT';

export type LoginAuthorizationOperationTypes = 'DEFAULT' | 'PROMPT';

export interface LoginOAuthResponse {
  id?: string;
  pluginTypeId?: string;
  rememberMyUsernameSelected?: boolean;
  showCaptcha?: false;
  showRememberMyUsername?: boolean;
  showThisIsMyDevice?: boolean;
  status?: string;
  thisIsMyDeviceSelected?: boolean;
  authorizeResponse?: AuthorizeResponse;
  error?: PingFederateError | string;
  errors?: Errors[];
  code?: string;
  error_description?: string;
}

export interface LoginAuthWithCredentialsResponse {
  authorizeResponse?: AuthorizeResponse;
  id?: string;
  pluginTypeId?: string;
  status?: string;
  error?: PingFederateError | string;
  encryptedToken?: string;
  fingerprint?: string;
  errors?: Errors[];
  code?: string;
  error_description?: string;
  resumeUrl?: string;
  showRememberMyUsername?: boolean;
  showThisIsMyDevice?: boolean;
  thisIsMyDeviceSelected?: boolean;
  showCaptcha?: boolean;
  rememberMyUsernameSelected?: boolean;
  message?: string;
  previouslySubmittedIdentifiers?: string[];
  user?: User;
  _links?: MfaLinks;
}

export interface SwapAuthForAccessTokensResponse {
  access_token?: string;
  expires_in?: number;
  id_token?: string;
  token_type?: string;
  error?: PingFederateError | string;
  errors?: Errors[];
  code?: string;
  error_description?: string;
  encyToken?: string;
  uid?: string;
}

export interface RedirectfulResponse {
  resumeUrl: string;
}
